import axios from 'axios'
import qs from 'qs'

// axios 配置
axios.defaults.timeout = 60 * 1000
axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT
axios.defaults.withCredentials = true

// http request 拦截器
axios.interceptors.request.use(
  function(config) {
    if (process.env) {
      if (
        process.env.VUE_APP_SITE_ID &&
        !(config.headers && config.headers['X-SITE-ID'])
      ) {
        config.headers['X-SITE-ID'] = process.env.VUE_APP_SITE_ID
      }
      if (
        process.env.VUE_APP_WX_ORIGINAL_ID &&
        !(config.headers && config.headers['WX-ORIGINAL-ID'])
      ) {
        config.headers['WX-ORIGINAL-ID'] = process.env.VUE_APP_WX_ORIGINAL_ID
      }
      if (
        sessionStorage.getItem('wxOpenId') &&
        !(config.headers && config.headers['WX-OPEN-ID'])
      ) {
        config.headers['WX-OPEN-ID'] = JSON.parse(
          sessionStorage.getItem('wxOpenId')
        )
      }
    }
    return config
  },
  function(err) {
    return Promise.reject(err)
  }
)

// 获取个人信息
const getSubcriber = headers =>
  axios({
    url: '/business/subscriber/',
    method: 'GET',
    headers
  })
// 获取个人信息web
const getSubcriberWeb = () =>
  axios({
    url: '/business/subscriber/',
    method: 'GET'
  })
// 获得官网站点信息
const getSite = () =>
  axios({
    url: '/business/site/',
    method: 'GET'
  })
// 获得首页轮播图列表
const getCarousels = () =>
  axios({
    url: '/business/carousel/',
    method: 'GET'
  })
// 获得轮播图点击跳转
const clickedOnCarousel = (carouselId, data) =>
  axios({
    url: `/business/carousel/${carouselId}/click`,
    method: 'POST',
    data
  })
// 获得全景跳转
const getPanoramas = () =>
  axios({
    url: '/business/panorama/',
    method: 'GET'
  })

// 获取栏目信息
const getCategories = () =>
  axios({
    url: '/business/category/',
    method: 'GET'
  })
// 获取栏目下文章列表
const getArticles = (category, params) =>
  axios({
    url: `/business/category/${category}/article`,
    method: 'GET',
    params
  })
// 获取栏目下文章内容
const getArticle = (category, article) =>
  axios({
    url: `/business/category/${category}/article/${article}`,
    method: 'GET'
  })
// 获取栏目下视频列表
const getVideos = (category, params) =>
  axios({
    url: `/business/category/${category}/video`,
    method: 'GET',
    params
  })
// 获取栏目下视频详细内容
const getVideo = (category, video) =>
  axios({
    url: `/business/category/${category}/video/${video}`,
    method: 'GET'
  })
// 获取栏目下页面内容
const getPage = category =>
  axios({
    url: `/business/category/${category}/page`,
    method: 'GET'
  })
// 附件下载
const download = (category, articleId, attachmentId) =>
  axios({
    url: `/business/category/${category}/article/${articleId}/attachment/${attachmentId}`,
    method: 'GET'
  })

// 收藏/取消收藏文章
const collectArticle = (category, article, headers) => {
  if (headers) {
    return axios({
      url: `/business/category/${category}/article/${article}`,
      method: 'POST',
      headers
    })
  } else {
    return axios({
      url: `/business/category/${category}/article/${article}`,
      method: 'POST'
    })
  }
}

// 获取全部瓷器珍品信息
const getCeramics = data =>
  axios({
    url: `/business/ceramic`,
    method: 'GET',
    data
  })
// 获取瓷器珍品信息
const getCeramic = ceramicId =>
  axios({
    url: `/business/ceramic/${ceramicId}/`,
    method: 'GET'
  })

// 瓷器珍品收藏/取消收藏信息
const getCeramicCollect = (ceramicId, headers) =>
  axios({
    url: `/business/ceramic/${ceramicId}/`,
    method: 'POST',
    headers
  })
// 瓷器珍品收藏/取消收藏信息 web
const getCeramicCollectWeb = ceramicId =>
  axios({
    url: `/business/ceramic/${ceramicId}/`,
    method: 'POST'
  })

const getSchema = schema =>
  axios({
    url: `/business/schema/${schema}/`,
    method: 'GET'
  })

// // 获取登录授权
// const getAuthorization = code =>
//   axios({
//     url: `/business/authorization`,
//     method: 'GET',
//     params: code
//   })

// 验证原绑定手机号码
const getMobileUnbind = data =>
  axios({
    url: `/business/mobile/unbind`,
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  })

// 获取解绑短信验证码
const getMobileUnbindCode = mobile =>
  axios({
    url: `/business/mobile/unbind/code`,
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify({
      mobile: mobile
    })
  })

// 获取短信验证码
const getMobileCode = mobile =>
  axios({
    url: `/business/mobile/code`,
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify({
      mobile: mobile
    })
  })

// 更新绑定手机号码
const getMobile = data =>
  axios({
    url: `/business/mobile`,
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  })

// 首页搜索
const getSearch = params =>
  axios({
    url: `/business/search/`,
    method: 'GET',
    params
  })

// 微信扫码登录
const loginByOpenPlatform = code =>
  axios({
    url: `/web/wechat/authorization`,
    method: 'GET',
    params: {
      code
    }
  })

// 登录弹框
const getSearchCount = params =>
  axios({
    url: `/business/search/count`,
    method: 'GET',
    params
  })

export {
  // 官网首页
  getSite,
  getCarousels,
  clickedOnCarousel,
  getPanoramas,
  // 栏目相关
  getCategories,
  getArticles,
  getArticle,
  getVideos,
  getVideo,
  getPage,
  download,
  collectArticle,
  // 瓷器珍品
  getCeramics,
  getCeramic,
  getCeramicCollect,
  getCeramicCollectWeb,
  // 数据字典
  getSchema,
  // 个人信息
  getSubcriber,
  getSubcriberWeb,
  // getAuthorization,
  getMobileCode,
  getMobile,
  // 首页搜索 及弹框
  getSearch,
  getSearchCount,
  loginByOpenPlatform,
  // 原手机解绑
  getMobileUnbindCode,
  getMobileUnbind
}
